// function initMV(o){const e=".js-konva-base",t=o?750:1920,n=o?1314:1200;var a=o?mateprod_image_sp_arr.length:mateprod_image_arr.length,r=0,i=!1,d=!1,c=0===$(window).scrollTop()?0:a-1,s=new Konva.Stage({container:"konva",width:t,height:n}),l=new Konva.Layer;s.add(l);var p=[...Array(a)].map(((e,i)=>{var d=new Image;return d.onload=function(){l.add(new Konva.Image({x:0,y:0,image:d,width:t,height:n,visible:i===c,id:"op"+String(i)}));const o=100*++r/a+"%";document.documentElement.style.setProperty("--mate-load-progress",o),r==a&&$(window).trigger("prodMvLoad")},d.src=o?mateprod_image_sp_arr[i]:mateprod_image_arr[i],d}));$(window).on("prodMvLoad",(function(){$(".c-loading").fadeOut(500,(function(){i=!0}))}));var m,g,u=0===$(window).scrollTop()?0:a-1;$("body").addClass("fixed"),$(e).on("touchstart",(function(o){h||(m=o.originalEvent.touches[0].clientY,o.preventDefault())})),$(document).on("touchstart",(function(o){h||(g=o.originalEvent.touches[0].clientY,o.preventDefault())}));let h=!1;function f(o){h=!0,$("body").addClass("fixed");const e=setInterval((function(){u===mateprod_timing_bg_change&&($(".js-mvBaseImg").toggleClass("is-changed"),$(".js-mvFirst").toggleClass("is-changed")),u===mateprod_timing_show_text&&$(".js-mvText").toggleClass("is-changed"),l.children[u]&&l.children.find((o=>o.attrs.id==="op"+u)).hide(),u+=o,l.children[u]&&l.children.find((o=>o.attrs.id==="op"+u)).show(),(1===o&&u>=p.length-1||-1===o&&u<=0)&&(h=!1,clearInterval(e),1===o?(d=!0,$("body").removeClass("fixed")):(d=!1,$("body").addClass("fixed")))}),mateprod_image_time/p.length)}$(e).on("wheel touchmove",(function(o){if(!i)return;if(h)return void o.preventDefault();const e=0===$(window).scrollTop();var t,n=o.originalEvent;if(n.changedTouches&&n.changedTouches[0]){var a=n.changedTouches[0].clientY;if(Math.abs(m-a)<20)return;t=m>a?1:-1,m=a}else t=n.deltaY>0?1:-1;return u>0&&!e?void 0:!(!d||1!==t)||void(u>=p.length&&e&&1===t||1===t&&u>=p.length-1||-1===t&&u<=0||(f(t),o.preventDefault()))})),$(window).on("wheel touchmove",(function(o){const e=0===$(window).scrollTop();var t,n=o.originalEvent;if(n.changedTouches&&n.changedTouches[0]){var a=n.changedTouches[0].clientY;if(Math.abs(g-a)<20)return;t=g>a?1:-1,g=a}else t=n.deltaY>0?1:-1;!e||1===t||u<=0||h||$("body").hasClass("fixed")||(f(t),o.preventDefault())}))}window.onunload=function(){},window.addEventListener("pageshow",(function(o){o.persisted&&window.location.reload()})),$((function(){$("html,body").stop().animate({scrollTop:0},100).promise().done((function(){$(window).trigger("prodPageReady")}))})),$(window).on("beforeunload pagehide",(function(o){$(".c-loading").show(),$("html,body").stop().animate({scrollTop:0},10)})),$(window).on("prodPageReady",(function(){const o=window.matchMedia("(min-width: 768px)"),e=!o.matches;function t(o){const e=!o.matches;$(".js-videoImageChange").each((function(){const o=$(this).data(e?"sp":"pc");$(this).attr("src",o)}))}o.addEventListener("change",t),t(o),initMV(e);const n=document.querySelector(".prod-matex-sideslide_list"),a=gsap.utils.toArray(".prod-matex-sideslide_item");gsap.to(a,{xPercent:-100*(a.length-1),ease:"none",scrollTrigger:{trigger:n,pin:!0,scrub:1,end:()=>"+="+n.offsetWidth}}),gsap.timeline({scrollTrigger:{trigger:".prod-matex-batt_over",start:"top center"}}).from(".prod-matex-batt_lead",{opacity:0,duration:.5}).from(".prod-matex-batt_desc",{opacity:0,duration:.5}).from(".prod-matex-batt_spec",{opacity:0,duration:.5}).from(".prod-matex-batt_notice",{opacity:0,duration:.5}),gsap.timeline({scrollTrigger:{trigger:".prod-matex-fold",start:"top center"}}).from(".prod-matex-fold_lead",{opacity:0,duration:1}).from(".prod-matex-fold_desc",{opacity:0,duration:1},"-=0.8").from(".prod-matex-fold_spec",{opacity:0,duration:1}).from(".prod-matex-fold_specSub",{opacity:0,duration:1},"-=0.5"),$(".js-prod-cmn-colorSlider").slick({arrow:!0,dots:!0,fade:!0});gsap.timeline({ease:"none",scrollTrigger:{trigger:".prod-cmn-color2",start:"top center",once:!0}}).set(".prod-cmn-colorOp_head",{y:20}).set(".prod-cmn-colorOp_lead",{y:20}).set(".prod-cmn-color2_slideName",{opacity:0,y:20}).set(".prod-cmn-color2 .slick-arrow",{opacity:0}).set(".prod-cmn-color2 .slick-dots",{opacity:0}).to(".prod-cmn-colorOp_head",{opacity:1,y:0,duration:.5}).to(".prod-cmn-colorOp_lead",{opacity:1,y:0,duration:.5}).to(".prod-cmn-colorOp_head, .prod-cmn-colorOp_lead",{opacity:0,duration:.5},"+=1").to(".prod-cmn-colorOp",{opacity:0,duration:1}).to(".prod-cmn-color2 .slick-arrow",{opacity:1,duration:.5},"-=0.5").to(".prod-cmn-color2 .slick-dots",{opacity:1,duration:.5},"-=0.5")}));

function initMV(o) {
	const e = ".js-konva-base",
		t = o ? 750 : 1920,
		n = o ? 1314 : 1200;
	var a = o ? mateprod_image_sp_arr.length : mateprod_image_arr.length,
		r = 0,
		i = !1,
		d = !1,
		c = 0 === $(window).scrollTop() ? 0 : a - 1,
		s = new Konva.Stage({
			container: "konva",
			width: t,
			height: n
		}),
		l = new Konva.Layer;
	s.add(l);
	var p = [...Array(a)].map(((e, i) => {
		var d = new Image;
		return d.onload = function() {
			l.add(new Konva.Image({
				x: 0,
				y: 0,
				image: d,
				width: t,
				height: n,
				visible: i === c,
				id: "op" + String(i)
			}));
			const o = 100 * ++r / a + "%";
			document.documentElement.style.setProperty("--mate-load-progress", o), r == a && $(window).trigger("prodMvLoad")
		}, d.src = o ? mateprod_image_sp_arr[i] : mateprod_image_arr[i], d
	}));
	$(window).on("prodMvLoad", (function() {
		$(".c-loading").fadeOut(500, (function() {
			i = !0
		}))
	}));
	var m, g, u = 0 === $(window).scrollTop() ? 0 : a - 1;
	$("body").addClass("fixed"), $(e).on("touchstart", (function(o) {
		h || (m = o.originalEvent.touches[0].clientY, o.preventDefault())
	})), $(document).on("touchstart", (function(o) {
		h || (g = o.originalEvent.touches[0].clientY, o.preventDefault())
	}));
	let h = !1;

	function f(o) {
		h = !0, $("body").addClass("fixed");
		const e = setInterval((function() {
			u === mateprod_timing_bg_change && ($(".js-mvBaseImg").toggleClass("is-changed"), $(".js-mvFirst").toggleClass("is-changed")), u === mateprod_timing_show_text && $(".js-mvText").toggleClass("is-changed"), l.children[u] && l.children.find((o => o.attrs.id === "op" + u)).hide(), u += o, l.children[u] && l.children.find((o => o.attrs.id === "op" + u)).show(), (1 === o && u >= p.length - 1 || -1 === o && u <= 0) && (h = !1, clearInterval(e), 1 === o ? (d = !0, $("body").removeClass("fixed")) : (d = !1, $("body").addClass("fixed")))
		}), mateprod_image_time / p.length)
	}
	$(e).on("wheel touchmove", (function(o) {
		if (!i) return;
		if (h) return void o.preventDefault();
		const e = 0 === $(window).scrollTop();
		var t, n = o.originalEvent;
		if (n.changedTouches && n.changedTouches[0]) {
			var a = n.changedTouches[0].clientY;
			if (Math.abs(m - a) < 20) return;
			t = m > a ? 1 : -1, m = a
		} else t = n.deltaY > 0 ? 1 : -1;
		return u > 0 && !e ? void 0 : !(!d || 1 !== t) || void(u >= p.length && e && 1 === t || 1 === t && u >= p.length - 1 || -1 === t && u <= 0 || (f(t), o.preventDefault()))
	})), $(window).on("wheel touchmove", (function(o) {
		const e = 0 === $(window).scrollTop();
		var t, n = o.originalEvent;
		if (n.changedTouches && n.changedTouches[0]) {
			var a = n.changedTouches[0].clientY;
			if (Math.abs(g - a) < 20) return;
			t = g > a ? 1 : -1, g = a
		} else t = n.deltaY > 0 ? 1 : -1;
		!e || 1 === t || u <= 0 || h || $("body").hasClass("fixed") || (f(t), o.preventDefault())
	}))
}
window.onunload = function() {}, window.addEventListener("pageshow", (function(o) {
	o.persisted && window.location.reload()
})), $((function() {
	$("html,body").stop().animate({
		scrollTop: 0
	}, 100).promise().done((function() {
		$(window).trigger("prodPageReady")
	}))
})), $(window).on("beforeunload pagehide", (function(o) {
	$(".c-loading").show(), $("html,body").stop().animate({
		scrollTop: 0
	}, 10)
})), $(window).on("prodPageReady", (function() {
	const o = window.matchMedia("(min-width: 768px)"),
		e = !o.matches;

	function t(o) {
		const e = !o.matches;
		$(".js-videoImageChange").each((function() {
			const o = $(this).data(e ? "sp" : "pc");
			$(this).attr("src", o)
		}))
	}
	o.addEventListener("change", t), t(o), initMV(e);
	const n = document.querySelector(".prod-matex-sideslide_list"),
		a = gsap.utils.toArray(".prod-matex-sideslide_item");
	// gsap.to(a, {
	// 	xPercent: -100 * (a.length - 1),
	// 	ease: "none",
	// 	scrollTrigger: {
	// 		trigger: n,
	// 		pin: !0,
	// 		scrub: 1,
	// 		end: () => "+=" + n.offsetWidth
	// 	}
	// }),
  gsap.timeline({
		scrollTrigger: {
			trigger: ".prod-matex-batt_over",
			start: "top center"
		}
	}).from(".prod-matex-batt_lead", {
		opacity: 0,
		duration: .5
	}).from(".prod-matex-batt_desc", {
		opacity: 0,
		duration: .5
	}).from(".prod-matex-batt_spec", {
		opacity: 0,
		duration: .5
	}).from(".prod-matex-batt_notice", {
		opacity: 0,
		duration: .5
	}), gsap.timeline({
		scrollTrigger: {
			trigger: ".prod-matex-fold",
			start: "top center"
		}
	}).from(".prod-matex-fold_lead", {
		opacity: 0,
		duration: 1
	}).from(".prod-matex-fold_desc", {
		opacity: 0,
		duration: 1
	}, "-=0.8").from(".prod-matex-fold_spec", {
		opacity: 0,
		duration: 1
	}).from(".prod-matex-fold_specSub", {
		opacity: 0,
		duration: 1
	}, "-=0.5"), $(".js-prod-cmn-colorSlider").slick({
		arrow: !0,
		dots: !0,
		fade: !0
	});
	gsap.timeline({
		ease: "none",
		scrollTrigger: {
			trigger: ".prod-cmn-color2",
			start: "top center",
			once: !0
		}
	}).set(".prod-cmn-colorOp_head", {
		y: 20
	}).set(".prod-cmn-colorOp_lead", {
		y: 20
	}).set(".prod-cmn-color2_slideName", {
		opacity: 0,
		y: 20
	}).set(".prod-cmn-color2 .slick-arrow", {
		opacity: 0
	}).set(".prod-cmn-color2 .slick-dots", {
		opacity: 0
	}).to(".prod-cmn-colorOp_head", {
		opacity: 1,
		y: 0,
		duration: .5
	}).to(".prod-cmn-colorOp_lead", {
		opacity: 1,
		y: 0,
		duration: .5
	}).to(".prod-cmn-colorOp_head, .prod-cmn-colorOp_lead", {
		opacity: 0,
		duration: .5
	}, "+=1").to(".prod-cmn-colorOp", {
		opacity: 0,
		duration: 1
	}).to(".prod-cmn-color2 .slick-arrow", {
		opacity: 1,
		duration: .5
	}, "-=0.5").to(".prod-cmn-color2 .slick-dots", {
		opacity: 1,
		duration: .5
	}, "-=0.5")
}));